import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import {
    BrowserRouter as Router,
    Link,
} from "react-router-dom";
import globals from 'react-global-configuration';
import { Container,Containertop, Containerpreguntas, Row,  Colseis, Coltres, Linkbtn,Txtinicio} from './styles'
import { Header } from '../Header';
import { ListOfResources } from '../ListOfResources';
import { ListaPatrocinadores } from '../ListaPatrocinadores';
import { ListOfEvents } from '../ListOfEvents';



export const EventoMultiple = (props) => {
    /*const _URL_REST = globals.get('_URL_REST')
    const [data, setData] = useState(null)

    let getdataenvent =  `${_URL_REST}/getinfolast`

 
    useEffect(() => {
        async function fetchData() {
          // You can await here
          const result = await axios(
            getdataenvent
        );

        setData(result.data);
          // ...
        }
        console.log('CALL....')
        fetchData();
    }, []);

    if (!data) {
        console.log('IS NULL')
        return <div></div>  
    }*/
    const [listSettings, setSettings] = useState(false);
    const [data, setData] = useState(false);

    const [showPreguntar, setshowPreguntar] = useState(true);
    const _URL_REST = globals.get('_URL_REST')
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`,
        );
        setSettings(result.data[0])
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);


    const fetchData = async () => {
        const result = await axios(
            `${_URL_REST}/getcategoriaeventos/${process.env.REACT_APP_EVENTO_ID}`,
        );
        console.log('R::',result.data)
        setData(result.data)
    };
  
    useEffect(() => {
        fetchData();
    },[]);

    const chageSetSettings = async () => {
        //console.log('listSettings',showPreguntar)
        if(showPreguntar){
            setshowPreguntar(false)
        }
        else{
            setshowPreguntar(true)
        }
    };

    const closeSetSettings = async () => {
        if(showPreguntar){
            setshowPreguntar(false)
        }
        else{
            setshowPreguntar(true)
        }
    };
    if(!listSettings) { return(<div></div>) }
    if(!data) { return(<div>nodata</div>) }
    if(listSettings.eventoActivo){
        return (
            <Fragment>
                <Header id={process.env.REACT_APP_EVENTO_ID}/>
                <Containertop>
                <p><b>¡Hola, {sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_NAMEUSERRADIO`)}!</b><br/>
                </p>
                <div dangerouslySetInnerHTML={{__html: listSettings.textoInicio}} />
                </Containertop>

                {
                    data
                    .map(item => 
                        
                        <Container key={`cat-${item.categoria}`}>
                            <ListOfEvents  url='getallademas' titlecontenedor={item.titulo} idcategoria={item.categoria} subtitle='' program='0' song={props.song} changeSong={props.changeSong}   />
                        </Container>
                    )
                }
                <Containertop>
                <div dangerouslySetInnerHTML={{__html: listSettings.textoFin}} />
                </Containertop>
                
                <Container>
                    <Row>
                    {listSettings.mostrarRecursos === 1 && (
                        <Coltres>
                            <ListOfResources idevento={process.env.REACT_APP_EVENTO_ID} title='Recursos adicionales'  />
                        </Coltres>
                    )}
                    </Row>
                    {listSettings.mostrarPatrocinador === 1 && (
                        <Row>
                            <ListaPatrocinadores idevento={process.env.REACT_APP_EVENTO_ID}  />
                        </Row>
                    )}
                </Container>
            </Fragment>
        )
    }else{
        setTimeout(function(){
            //console.log('check again')
            fetchSettings();
        },30000);
          
        return (<Fragment><Header/><Container>
                    
                    <Txtinicio>{listSettings.eventoActivoTXT}</Txtinicio>
                </Container></Fragment>)
    }
}